import React, { FC, ReactNode, useEffect, useState } from 'react'
import { createStyles, TextInput, TextInputProps } from '@mantine/core'
import { XelaColor } from '@/XelaReact'
import { IconX } from '@tabler/icons-react'

interface XNationalInputProps {
  value: string | number | readonly string[] | undefined | null
  placeholder: string | undefined
  focused: boolean
  icon?: ReactNode
}

const useStyles = createStyles((theme, params: XNationalInputProps) => ({
  root: {
    fontFamily: 'Nunito Sans',
    position: 'relative',
    width: '100%',
  },

  input: {
    fontSize: '14px',
    fontWeight: 700,
    height: '56px',
    padding: params.icon ? '26px 24px 6px 35px !important' : '26px 24px 6px 24px !important',
    border: '1px solid #E8E8EA',
    borderRadius: '18px',
    '&:hover, &:focus': {
      padding: params.icon ? '25px 23px 5px 34px !important' : '25px 23px 5px 23px !important',
      border: '2px solid #003CFF',
    },
    '&:focus': {
      color: '#003CFF !important',
    },
    '&::placeholder': {
      color: XelaColor.Gray10,
      fontWeight: 400,
    },
  },

  label: {
    fontSize: params.focused || params.placeholder || params.value ? '10px' : '13px',
    lineHeight: '15px',
    fontWeight: 600,
    position: 'absolute',
    pointerEvents: 'none',
    paddingLeft: params.icon ? '35px !important' : '25px !important',
    transition: 'all 300ms ease',
    paddingTop: `${params.focused || params.placeholder || params.value ? '12px !important' : '20px !important'}`,
    zIndex: 1,
    color: XelaColor.Gray3,
    '&:hover, &:focus': {
      paddingLeft: params.icon ? '35px !important' : '25px !important',
    },
  },
}))

const XNationalInput: FC<
  Omit<TextInputProps, 'value'> & {
    value?: string | number | readonly string[] | undefined | null
    onClear?: () => void
  }
> = (props) => {
  const [val, setVal] = useState<string | number | readonly string[] | undefined | null>('')

  const [focused, setFocused] = useState(false)

  const { classes } = useStyles({
    value: val,
    placeholder: props.placeholder,
    focused,
    icon: props.icon,
  })

  useEffect(() => {
    setVal(props.value)
  }, [props.value])

  const { onClear, ...rest } = props
  return (
    <TextInput
      {...rest}
      autoComplete={'off'}
      classNames={classes}
      label={props.label ? props.label : 'Input'}
      value={val || ''}
      onFocus={(event) => {
        if (!props.readOnly) {
          setFocused(true)
        }

        if (props.onFocus) {
          props.onFocus(event)
        }
      }}
      onBlur={(event) => {
        if (!props.readOnly) {
          setFocused(false)
        }

        if (props.onBlur) {
          props.onBlur(event)
        }
      }}
      onChange={(e) => {
        if (props.onChange) {
          props.onChange(e)
        }

        setVal(e.target.value)
      }}
      {...(props.value && onClear
        ? {
            rightSection: (
              <IconX
                size={20}
                color={XelaColor.Gray7}
                onClick={() => {
                  setVal('')
                  if (onClear) {
                    onClear()
                  }
                }}
                style={{ cursor: 'pointer', padding: '4px' }}
              />
            ),
          }
        : {})}
    />
  )
}

export default XNationalInput
